import * as types from "./mutation-types";
import { oportunidade_empty, oportunidade_estatistica_empty } from "./getters";
import _ from "lodash";

export default {
  [types.SET_OPORTUNIDADES](state, payload) {
    state.oportunidades = payload;
  },
  [types.SET_OPORTUNIDADESLIST](state, payload) {
    state.oportunidades_list = payload;
  },
  [types.SET_OPORTUNIDADE](state, payload) {
    payload = _.merge(oportunidade_empty(), payload);

    if (!payload.galeria_arquivo) {
      payload.galeria_arquivo = oportunidade_empty().galeria_arquivo;
    }

    state.oportunidade = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_ODS](state, payload) {
    state.ods = payload;
  },
  [types.SET_MODELO_CONTRAPARTIDAS](state, payload) {
    state.modelo_contrapartidas = payload;
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [types.SET_OPORTUNIDADE_ESTATISTICA](state, payload) {
    payload = _.merge(oportunidade_estatistica_empty(), payload);
    state.oportunidade_estatisticas = payload;
  },
};
